export const testimonials = [
  {
    name: 'Dr. Michael Reed',
    role: 'Orthodontist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/e70fb4d8-199f-41ad-9b00-3e33890c1092.jpg',
    quote:
      'What I look for in an educational resource is a clear structure that helps me organize the different elements of a case. A framework that brings clinical findings, objectives, and treatment sequencing into one place can make the review process easier to follow. I would use resources like these as a reference alongside my own clinical assessment.',
  },
  {
    name: 'Dr. Sarah Mitchell',
    role: 'General Dentist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/4ba73b83-f36d-4c32-a642-8c6d4f6a77bf.jpg',
    quote:
      'Clear aligner planning involves several details that need to be considered together. I appreciate educational materials that separate the process into understandable stages and provide practical questions to review. Worksheets and checklists can be useful for organizing my notes and identifying areas that deserve further attention.',
  },
  {
    name: 'Dr. Daniel Foster',
    role: 'Orthodontist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/687e07fa-ca9c-4d95-9dfe-27b16053856d.jpg',
    quote:
      'A structured case-review framework can be helpful when evaluating a digital treatment plan. I find it valuable to have a consistent way to document objectives, review proposed movements, and summarize questions before making clinical decisions. The important part is using the framework to support—not replace—professional judgment.',
  },
  {
    name: 'Dr. Emily Carter',
    role: 'General Dentist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/fabb882e-247d-48d4-8403-f30bbbec930e.jpg',
    quote:
      'I value resources that make complex topics easier to organize. A workbook that brings assessment, planning, and monitoring considerations together can serve as a useful educational reference. I would especially look for clear worksheets that I can adapt to my own documentation and learning process.',
  },
  {
    name: 'Dr. Carlos Bennett',
    role: 'Orthodontist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/dd2670ac-710d-49da-a914-0f69ffea84b1.jpg',
    quote:
      'The value of a planning resource is in how clearly it organizes the questions that need to be considered. A consistent review structure can help professionals document their reasoning and revisit the relevant information throughout treatment. It should always be combined with patient-specific assessment and current clinical guidance.',
  },
  {
    name: 'Dr. Laura Jiménez',
    role: 'Orthodontist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/ded7b176-18de-434e-8984-86ccd0c31fdd.jpg',
    quote:
      'Having assessment, objectives, biomechanics, and monitoring laid out as connected stages is exactly the kind of structure I want in a reference. A one-page summary I can return to at every reassessment makes it much easier to see what was decided and why.',
  },
]
